import React from 'react';
import {IRoutableModule} from '../../router/routing.infra';

const loader = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {};
};

const ConnectivityGuruDataView = () => <div>Hello Connectivity Guru Data</div>;

export default {
    loader,
    Component: ConnectivityGuruDataView,
    storeAs: 'connectivityGuruDataStore'
} as IRoutableModule;
